export default {
  eyebrow: 'Partner portal',
  title: 'Account',
  description: 'Your partner account details.',
  page: {
    read_only_notice: 'Read-only. Click Edit to change any value.',
    editing_notice: 'Editing — changes are visible to your team and customers.',
  },
  profile: {
    form: {
      name: {
        label: 'Partner name',
        hint: 'The legal / entity name. Used on billing documents.',
      },
      display_name: {
        label: 'Consumer display name',
        hint: 'The "Powered by ___" label your customers see across your restaurants. Defaults to the partner name if left blank.',
      },
      support_email: {
        label: 'Contact email',
        hint: 'Where FoodAmigos and your customers can reach you. Your login email stays unchanged.',
      },
      invoicing_emails: {
        label: 'Invoice emails',
        hint: 'Receipts for invoices billed to you are sent to each of these addresses. Leave empty to use your login email.',
        placeholder: 'Your login email',
      },
    },
  },
  buttons: {
    edit: 'Edit',
    cancel: 'Cancel',
    save: 'Save',
  },
  toasts: {
    load_error: 'Could not load your account details.',
    failed_to_save_changes: 'Failed to save changes',
    changes_got_saved: 'Changes got saved',
  },
};
